'use strict';

/**
 * Change server data to list data.
 *
 * @param {Object} data - movie for preparing
 *
 * @return {Object} ready data
 */
module.exports = function ( data ) {
    var genresName = data.genres.map(function ( item ) {
        return item.name;
    });

    data.genre = genresName.join(', ');

    if ( data.cover ) {
        data.cover = 'url(' + core.backend.host + data.cover + ')';
    } else {
        data.cover = '';
    }
    data.prepared = true;

    return data;
};
